import { gql } from 'graphql-request'

export const DELETE_BOOK_REPORT = gql`
  mutation DeleteBookReport($ids: [Int!]!) {
    deleteBookReport(ids: $ids)
  }
`
